import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import Locate from "../../images/locate.svg";
import Distance from "../../images/distance.svg";
import BackButton from "../bars/BackButton";
import PNDicon from '../tourist/Car.svg'

function TouristPlace() {
  const location = useLocation();
  const state = location.state || {};
  const menuVisibility = state.menuVisibility || {};
  const id = localStorage.getItem('hotel-id');
  const [chechOutLocalStorage, setchechOutLocalStorage] = useState(localStorage.getItem("checkout") ? true : false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const descriptionRef = useRef(null);

    //Seemore/less
        useEffect(() => {
        const checkDescriptionLength = () => {
          if (descriptionRef.current) {
            const lineHeight = parseInt(window.getComputedStyle(descriptionRef.current).lineHeight, 10);
            const maxHeight = lineHeight * 15;
            const contentHeight = descriptionRef.current.scrollHeight;
            setIsTruncated(contentHeight > maxHeight);
          }
        };
    
        checkDescriptionLength();
        window.addEventListener('resize', checkDescriptionLength);
        return () => {
          window.removeEventListener('resize', checkDescriptionLength);
        };
      }, []);
    
      const handleToggle = () => {
        setIsExpanded(prev => !prev);
      };

  return (
    <div>
      <div className="pb-28 relative">
        <div className="absolute top-3 left-3">
          <BackButton whiteTheme={true} />
        </div>
        <div
          style={{
            backgroundImage: `url(${state.image})`,
          }}
          className="cover-img-div sm:h-[300px] h-[190px] bg-cover bg-no-repeat w-full "
        ></div>
        <div className="section-wrap mx-4 mt-6 sm:mt-14">
          <div className="guestName sm:text-left text-left">{state.name}</div>
          {state.distance !== null ? (
            <div className="text-[#9A9A9A] font-medium text-[11px] sm:justify-start justify-start mt-1 flex space-x-1">
              <img src={Distance} alt="distance" />
              <div>
                {state.name} , {state.distance} KM Away
              </div>
            </div>
          ) : null}
          {/* <div className="mt-4 guideP sm:text-left text-left">
            {state.description}
          </div> */}
          <div className='mt-4 guideP sm:text-left text-left'>
            <p
              className={`${isExpanded ? 'expanded' : 'truncated'}`}
              ref={descriptionRef}
              style={{
                maxHeight: isExpanded ? 'none' : '16em',
                overflow: 'hidden',
              }}
            >
              {state.description}
            </p>
            {isTruncated && (
              <button onClick={handleToggle}className="text-[#6b6bec] cursor-pointer bg-transparent font-[500]">
                {isExpanded ? 'See less...' : 'See more...'}
              </button>
            )}
          </div>
          {state.map === null ? " " : 
            <div className="mt-8 flex space-x-4 items-start sm:justify-start justify-start">
            <div className="text-[15px] font-semibold text-[#FFF]">Locate </div>
            <img src={Locate} />
          </div>
          }
          {state.map && <a href={state.map} target="_blank" className="mt-2 flex w-full sm:mx-auto sm:justify-center justify-start rounded-sm overflow-hidden">
            <img className="h-20 object-cover w-1/3" src={state.image} />
            <div className="py-3 pl-3 pr-10 w-full bg-[#FFFFFF] flex justify-center flex-col break-all">
              <div className="text-xs font-medium text-[#000]">{state.name}</div>

              <div className="text-blue-500 text-xs mt-1 truncate sm:w-[90%] w-[70%] ">{state.map}</div>
            </div>
          </a>}
          {menuVisibility.IsPickup === 1 &&
            <div className="mt-[30px] w-full flex justify-between items-center bg-[white] rounded-sm h-[70px]">
              <div className="flex items-center">
                <img src={PNDicon} alt="Pick and Drop Icon" className="h-[55px] ml-3" />
                <span className="text-xs font-medium text-[#000] ml-3">Pick And Drop</span>
              </div>
              <Link
                 to={`/pick-and-drop/${id}`}
                 state={{place:state.name}}
                 >
                <button className="bg-[#5550d2] text-white text-xs py-2 h-[30px] px-3 mr-3 rounded-full">
                  Book Now
                </button>
              </Link>
            </div>
          }
        </div>
      </div>
    </div >
  );
}

export default TouristPlace;
